<template>
  <b-table :items="items" responsive :fields="fields" :busy="loading">
    <template #head(id)="row">
      {{ row.label }}
      <a href="#" @click.prevent="$router.push({ name: 'procesos-listado-orden-de-pedido' })">Ir</a>
    </template>
    <template #cell(actions)="row">
      <a href="#" @click.prevent="togglePriority(row.item.id)">Prioridad</a>
    </template>
    <template #cell(status)="row">
      <a href="#">{{ row.item.status }}</a>
    </template>
    <template #cell(priority)="row">
      <i class="fa fa-lg fa-arrow-up text-danger" v-if="row.item.priority"></i>
      <i class="fa fa-lg fa-arrow-down text-secondary" v-else></i>
    </template>
    <template #table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  name: "OpList",
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: [
        { key: "id", label: "OP" },
        "delivery_date",
        "priority",
        "status",
        "progress",
        "kilograms",
        "completed_kilograms",
        { key: "actions", label: "" }
      ]
    };
  },
  methods: {
    async togglePriority(id) {
      try {
        await this.$axios.put("/api/v1/purchase_order/" + id + "/toggle_priority/");
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit("refresh");
      }
    }
  }
};
</script>

<style></style>
